export const EMAIL = "aldric@joyastick.com";
export const LOCATION = "Toronto, Canada · Eastern Time";

// Put the PDF in /public (e.g. public/resume.pdf) and set this to "/resume.pdf".
// While empty, the résumé button is hidden.
export const RESUME = "";

// A link with an empty href is skipped everywhere it's used.
export const links = [
  { label: "GitHub", note: "Code & projects", href: "https://github.com/Joyastick" },
  { label: "YouTube", note: "Videos & vlogs", href: "https://www.youtube.com/@AldricJoya" },
  { label: "LinkedIn", note: "Let's connect", href: "https://www.linkedin.com/in/aldric-joya/" },
  { label: "Ko-fi", note: "Support my work", href: "https://ko-fi.com/joyastick" },
  { label: "Discord", note: "MeleeVS community", href: "https://discord.gg/UVsxZSUXFR" },
].filter((l) => l.href);
